<template>
  <div class="bb-timer-delete-modal">
    <div class="bb-timer-delete-modal__title">
      Do you really want to delete tracked time?
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimerDeleteModal'
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bb-timer-delete-modal {
    width: 484px;
    padding: 55px 0 45px 0;
    text-align: center;

    &__title {
      font-size: 15px;
      line-height: 18px;
      font-weight: 400;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/TimerControl/TimerDeleteModal.vue